import { Link } from "@tanstack/react-router";
import { Bell, Menu, Moon, Search, Sun } from "lucide-react";
import { useTheme } from "@/lib/theme";
import { useAuth } from "@/lib/auth";
import { Avatar, AvatarFallback } from "@/components/ui/avatar";

export function CustomerTopbar({
  onToggleSidebar,
}: {
  onToggleSidebar: () => void;
}) {
  const { theme, toggle } = useTheme();
  const { logout } = useAuth();
  return (
    <header className="sticky top-0 z-30 border-b border-border bg-background/80 backdrop-blur-xl">
      <div className="flex h-16 items-center gap-3 px-4 md:px-6">
        <button
          onClick={onToggleSidebar}
          className="grid h-9 w-9 place-items-center rounded-lg hover:bg-muted"
        >
          <Menu className="h-4 w-4" />
        </button>
        <div className="relative hidden md:block">
          <Search className="pointer-events-none absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-muted-foreground" />
          <input
            placeholder="Search your orders, tickets…"
            className="h-10 w-80 rounded-lg border border-input bg-card pl-9 pr-3 text-sm shadow-sm outline-none focus:ring-2 focus:ring-ring/40"
          />
        </div>
        <div className="ml-auto flex items-center gap-2">
          <Link
            to="/shop"
            className="hidden sm:inline-flex h-9 items-center rounded-lg border border-border px-3 text-xs font-medium hover:bg-muted"
          >
            Storefront
          </Link>
          <button
            onClick={toggle}
            className="grid h-9 w-9 place-items-center rounded-lg border border-border hover:bg-muted"
          >
            {theme === "dark" ? (
              <Sun className="h-4 w-4" />
            ) : (
              <Moon className="h-4 w-4" />
            )}
          </button>
          <button className="relative grid h-9 w-9 place-items-center rounded-lg border border-border hover:bg-muted">
            <Bell className="h-4 w-4" />
            <span className="absolute right-2 top-2 h-2 w-2 rounded-full bg-destructive ring-2 ring-background" />
          </button>
          <button
            onClick={logout}
            title="Sign out"
            className="flex items-center gap-2 rounded-lg p-1 pr-2 hover:bg-muted"
          >
            <Avatar className="h-8 w-8">
              <AvatarFallback>AM</AvatarFallback>
            </Avatar>
            <div className="hidden sm:block text-left leading-tight">
              <div className="text-xs font-semibold">Aarav Mehta</div>
              <div className="text-[10px] text-muted-foreground">
                Gold member
              </div>
            </div>
          </button>
        </div>
      </div>
    </header>
  );
}